import { render, staticRenderFns } from "./DocAndPromo.vue?vue&type=template&id=555f29fe&scoped=true&"
import script from "./DocAndPromo.vue?vue&type=script&lang=js&"
export * from "./DocAndPromo.vue?vue&type=script&lang=js&"
import style0 from "./DocAndPromo.vue?vue&type=style&index=0&id=555f29fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f29fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VLabel,VRow})
